import type { Pattern } from '@/entities/pattern';
import { useGetPatternsByWatchlistIdQuery } from '@/entities/pattern';
import { useSelectedPatternWatchlistId } from '@/entities/pattern-watchlist';

interface UseAutoLoadPatternsResult {
    patterns: Pattern[] | undefined;
    isLoading: boolean;
    isFetching: boolean;
    error?: unknown;
}

// Return patterns from the actual selected watchlist
export const useAutoLoadPatterns = (): UseAutoLoadPatternsResult => {
    const selectedPatternWatchlistId = useSelectedPatternWatchlistId();
    const {
        data: patterns,
        isLoading,
        isFetching,
        error,
    } = useGetPatternsByWatchlistIdQuery(selectedPatternWatchlistId ?? 0, {
        skip: !selectedPatternWatchlistId, // Keep skip to avoid API call if no watchlist is selected
    });

    // If no watchlist is selected, return initial state
    if (!selectedPatternWatchlistId) {
        return {
            patterns: undefined,
            isLoading: false,
            isFetching: false,
            error: undefined,
        };
    }

    return {
        patterns,
        isLoading,
        isFetching,
        error,
    };
};
